import { Component,OnInit } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion'
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-mobileoptions',
  imports: [MatMenuModule,MatIconModule,MatButtonModule],
  templateUrl: './mobileoptions.component.html',
  styleUrl: './mobileoptions.component.css'
})
export class MobileoptionsComponent {
  isMobile=false;
 constructor(private router: Router,private deviceService: DeviceDetectorService) { }

 ngOnInit(): void {
  this.isMobile=this.deviceService.isMobile();
 }
  navigateWithParam(param:string) {
   
    
    if(!this.isMobile)
      this.router.navigate(['/marriagemenu', param]);
    else
      this.router.navigate(['/mobilemarriagemenu', param]); 
  }
}
